import axios from "axios";
import { FHIRApi } from "./components/service/fhirAPI";

export async function giveEveryData(patientId) {
    const data = await FHIRApi("", patientId);
    // const validation = await validateFhirData(data)
    // const isValid = validation.issue[0].details.text === "All OK"
        const resourceData = data.entry;
    return transformData(resourceData)
    // if (isValid) {
    //     const resourceData = data.entry;
    // return transformData(resourceData)
    // } else {
    //     return {
    //         issue: validation.issue,
    //         data: false
    //     }
    // }
}

const transformData = (resourceData) => {
    const reqData = resourceData.reduce((map, item) => {
        const resourceType = item.resource.resourceType;
        if (!map.has(resourceType)) {
            map.set(resourceType, []);
        }
        map.get(resourceType).push(item);
        return map;
    }, new Map());
    const mappedData = Array.from(reqData).map(([key, value]) => {
        return {
            resourceType: key,
            objects: value
        };
    });
    return mappedData;
}




export const getMappedData = (objects) => {
    const requiredObservation = objects?.reduce((map, item) => {
        const observation = item.resource.code.text
        if (!map.has(observation)) {
            map.set(observation, [])
        }
        map.get(observation).push(item)
        return map;
    }, new Map())
    return requiredObservation
}


export const getConditionId = (conditionType, mappedConditions) => {

    const condition = mappedConditions?.find((i) => i.conditionType === conditionType)
    const id = condition?.objects[0]?.resource.id
    return id
}


export const filterEncounterByConditionId = (encounterObjects, conditionId) => {
    const filteredEncounterObjects = encounterObjects?.filter((encounter) =>
        encounter?.resource?.diagnosis?.some(
            (diagnosis) =>
                diagnosis?.condition?.reference?.substring(diagnosis?.condition?.reference?.lastIndexOf("/") + 1) === conditionId?.toString()
        )
    );
    return filteredEncounterObjects
}



export const validateFhirData = async (payload) => {
    const headers = {
        'X-Api-Key': 'sJdH2KXzI14lWunvyxTQhEDQLTf54z396LtIyVya'
    };
    try {
        const { data } = await axios.post('https://fhir.s37vcloskatg.static-test-account.isccloud.io/Condition/$validate', payload, { headers })
        return data
    } catch (error) {
        return error
    }
}

  // function renameKeys(json, oldKey, newKey) {
  //   if (json && typeof json === "object") {
  //     if (json.hasOwnProperty(oldKey)) {
  //       json[newKey] = json[oldKey];
  //       delete json[oldKey];
  //     }
  //     for (let key in json) {
  //       if (json.hasOwnProperty(key) && typeof json[key] === "object") {
  //         renameKeys(json[key], oldKey, newKey);
  //       }
  //     }
  //   }
  //   return json;
  // }

